export default "__VITE_ASSET__BWqsOSFu__"